@if (form) {
    <ng-container [formGroup]="form">
        @if (!isAdhesive) {
            <td class="cutter-selection" [class.empty]="!selectedMill" [matTooltip]="selectedMill?.name">
                <div class="showname">{{ selectedMill?.name }}</div>
                <input
                    #millInput
                    [matAutocomplete]="autoCompleteMill"
                    autocomplete="off"
                    formControlName="asphaltmill_id"
                    matInput
                    placeholder="Molen"
                    type="text" />
                <mat-autocomplete
                    #autoCompleteMill="matAutocomplete"
                    [displayWith]="emptystring"
                    [panelWidth]="200"
                    (optionSelected)="millSelectionChange($event)"
                    autoActiveFirstOption>
                    @for (mill of filteredMills | async; track mill) {
                        <mat-option
                            [class.mat-active]="selectedMill == mill"
                            [disabled]="!mill.asphalt || mill.asphalt.length === 0"
                            [value]="mill">
                            {{ mill.name }}
                        </mat-option>
                    }
                </mat-autocomplete>
            </td>
            <td
                class="cutter-selection"
                [class.empty]="!asphaltText || asphaltText.length === 0"
                [class.info]="
                    form.get('asphaltname')?.value &&
                    (!selectedAsphalt || form.get('asphaltname').value !== selectedAsphalt.asphalt.name)
                "
                [matTooltip]="asphaltText ? asphaltText : ('asphalttype' + (selectedMill ? '' : '-nomill') | tt)">
                <div class="showname">{{ asphaltText }}</div>
                <input
                    #asphaltInput
                    [matAutocomplete]="autoCompleteAsphalt"
                    (change)="asphaltTextChanged($event)"
                    autocomplete="nofill"
                    formControlName="asphaltname"
                    matInput
                    placeholder="Zoek naar asfalt..."
                    type="text" />
                <mat-autocomplete
                    #autoCompleteAsphalt="matAutocomplete"
                    [displayWith]="emptystring"
                    [panelWidth]="350"
                    (optionSelected)="asphaltSelectionChange($event)"
                    autoActiveFirstOption>
                    @if (selectedMill) {
                        @for (asphalt of filteredAsphalt | async; track asphalt) {
                            <mat-option [value]="asphalt"> ({{ asphalt.code }}) {{ asphalt.asphalt.name }} </mat-option>
                        }
                    }
                </mat-autocomplete>
            </td>
        }
        @if (isAdhesive) {
            <td class="text-input">
                <input
                    #asphaltNameInput
                    autocomplete="off"
                    formControlName="asphaltname"
                    matInput
                    maxlength="300"
                    placeholder="Kleeflaag"
                    type="text" />
            </td>
        }
        @if (!isAdhesive) {
            <td
                class="number-input"
                [class.info]="
                    form.get('asphaltcode')?.value &&
                    (!selectedAsphalt || form.get('asphaltcode').value !== selectedAsphalt.code)
                "
                [matTooltip]="'asphaltcode' | tt">
                <input autocomplete="off" formControlName="asphaltcode" matInput placeholder="Asfaltcode" type="text" />
            </td>

            <td class="number-input">
                <input
                    #tonsInput
                    [decimalInput]="2"
                    appDecimalInput
                    autocomplete="off"
                    formControlName="tons"
                    matInput
                    placeholder="0"
                    type="text" />
            </td>

            <td class="number-input">
                <input
                    [decimalInput]="2"
                    appDecimalInput
                    autocomplete="off"
                    formControlName="thickness"
                    matInput
                    placeholder="0"
                    type="text" />
            </td>
        }
        <td class="number-input">
            <input
                [decimalInput]="2"
                appDecimalInput
                autocomplete="off"
                formControlName="surface"
                matInput
                placeholder="0"
                type="text" />
        </td>
        @if (!isAdhesive) {
            <td class="number-input">
                <input
                    [decimalInput]="2"
                    appDecimalInput
                    autocomplete="off"
                    formControlName="temperature"
                    matInput
                    placeholder="0"
                    type="text" />
            </td>
        }
        <td class="cutter-selection">
            <div class="d-flex">
                <mat-select formControlName="application" placeholder="Toepassing">
                    @for (application of applicationList; track application) {
                        <mat-option [value]="application.key">
                            {{ application.name }}
                        </mat-option>
                    }
                </mat-select>
            </div>
        </td>
        <td class="text-input">
            <input
                autocomplete="off"
                formControlName="comment"
                matInput
                maxlength="300"
                placeholder="Opmerking"
                type="text" />
        </td>
        @if (!formsDisabled) {
            <td>
                <button
                    class="icon-button-medium"
                    (click)="removeAsphaltPlanning()"
                    color="warn"
                    mat-icon-button
                    matTooltip="Verwijder"
                    matTooltipClass="warn-background"
                    matTooltipPosition="right"
                    tabindex="-1">
                    <mat-icon fontSet="fas" fontIcon="fa-trash"></mat-icon>
                </button>
            </td>
        }
    </ng-container>
}
